import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import { Dropdown, Icon, List } from '@pella/sash-framework';
import { useBranchContext } from '../../../../context/BranchContext';

import ProductMenu from './menu-types/product';
import PerformanceMenu from './menu-types/performance';
import ProMenu from './menu-types/pros';

const Navigation = ({ data }) => {
	const { currentBranch } = useBranchContext();
	const [activeIndex, setActiveIndex] = useState(0);

	const onTabClick = (index) => setActiveIndex(index);

	return (
		<nav
			aria-label='Desktop Navigation'
			className='pellaNav z-10 flex flex-row flex-wrap items-center'
		>
			{data.map((primary, index) => {
				let directLink = primary.direct_link;

				if (currentBranch?.branch_url && primary.direct_link === '/where-to-buy/') {
					directLink = currentBranch.branch_url + 'showrooms/';
				}

				return (
					<div
						className={`pellaNav-primary headerNavItem-${index}`}
						key={index}
					>
						{directLink && (
							<Link
								to={directLink}
								className='block h-full border-b-4 border-b-transparent text-base font-semibold no-underline hover:border-b-primary focus:border-b-primary active:border-b-primary lg:px-1.5 lg:pb-2.5 lg:pt-4 xl:px-2 xl:text-lg 2xl:px-2.5 3xl:px-4'
							>
								{primary.primary_heading}
							</Link>
						)}

						{primary.secondary_nav?.[0] && (
							<Dropdown
								className='group/dd !static'
								backdropClass='bg-black/40 top-full absolute w-screen h-screen backdrop-blur-lg -z-1 left-1/2 -translate-x-1/2'
								hasBackdrop
							>
								<Dropdown.Trigger
									className='flex h-full items-center border-b-4 border-b-transparent tracking-[inherit] text-black hover:border-b-primary focus:border-b-primary active:border-b-primary group-focus-within/dd:border-b-primary motion-safe:transition lg:pb-2.5 lg:pl-1.5 lg:pr-1.5 lg:pt-4 xl:px-2 2xl:px-2.5 3xl:pl-4'
									activeClass='!border-b-primary'
								>
									<span className='text-base font-semibold xl:text-lg xl:tracking-normal'>{primary.primary_heading}</span>
									<Icon
										name='keyboard_arrow_down'
										className='2xl:ml-1'
									/>
								</Dropdown.Trigger>

								<Dropdown.Content className='left-1/2 z-[20] w-screen -translate-x-1/2 border-0 border-t border-t-neutral-200 !p-0'>
									{primary.secondary_nav?.length > 1 && (
										<List
											bullets='none'
											layout='inline'
											className='navTabs relative space-x-6 border-b border-b-neutral-100 bg-neutral-25 px-12'
										>
											{primary.secondary_nav.map((secondary, index) => (
												<li key={index}>
													{secondary.direct_link && (
														<Link
															className='flex items-center border-b-4 border-b-transparent py-3 no-underline hover:border-b-primary focus:border-b-primary active:border-b-primary'
															to={secondary.direct_link}
														>
															<span className='text-lg font-semibold'>{secondary.secondary_heading}</span>
														</Link>
													)}

													{!secondary.direct_link && (
														<>
															<button
																className={`border-b-4 py-3 text-lg font-semibold text-black no-underline hover:border-b-primary focus:border-b-primary active:border-b-primary ${activeIndex === index ? 'border-b-primary' : 'border-b-transparent'}`}
																onClick={() => onTabClick(index)}
															>
																{secondary.secondary_heading}
															</button>

															<div className={`absolute left-0 top-full mt-px w-full bg-white ${activeIndex !== index ? 'hidden' : ''}`}>
																<ProductMenu
																	data={secondary}
																	smallCol
																/>
															</div>
														</>
													)}
												</li>
											))}
										</List>
									)}

									{primary.secondary_nav.length === 1 && primary.menu_type === 'product' && (
										<ProductMenu
											data={primary.secondary_nav[0]}
											smallCol={index !== 0}
										/>
									)}
									{primary.menu_type === 'performance' && <PerformanceMenu data={primary.secondary_nav[0]} />}
									{primary.menu_type === 'pro' && <ProMenu data={primary.secondary_nav[0]} />}
								</Dropdown.Content>
							</Dropdown>
						)}
					</div>
				);
			})}

			<noscript>
				<style
					dangerouslySetInnerHTML={{
						__html: `
							.sash-Dropdown:hover .sash-DropdownTrigger,
							.sash-Dropdown:focus-within .sash-DropdownTrigger {
								border-bottom-color: --var(--tw-color-primary)
							}

							.sash-Dropdown:hover .sash-DropdownContent,
							.sash-Dropdown:focus-within .sash-DropdownContent {
								display: block;
							}

							.navTabs li:hover > div,
							.navTabs li:focus-within > div {
								display: block;
							}
						`,
					}}
				/>
			</noscript>
		</nav>
	);
};

Navigation.propTypes = {
	data: PropTypes.array.isRequired,
};

export default Navigation;
